import { storage as localStorage } from "../utils/storage";

async function getUsername() {
  return (
    (await localStorage.get("name")) ??
    (await localStorage.get("name")) ??
    (await localStorage.get("email"))
  );
}

async function getAvatar() {
  const img = await localStorage.get("img");
  if (img && img !== "undefined") {
    return <img src={img ?? ""} alt="User Avatar" className="avatar" />;
  }
  const username = await getUsername();
  const initials =
    username && username.split(" ").length > 1
      ? username
          .split(" ")
          .map((name: string) => name.charAt(0))
          .join("")
          .toUpperCase()
      : username?.substring(0, 2).toUpperCase();
  return initials;
}

export { getUsername, getAvatar };
